import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useEffect, useState } from 'react';
import { useApiClient } from '@client/hooks/useApiClient';
import { callApi } from '@client/utils/apiUtils';
const CategoriesContext = React.createContext(null);
export const CategoriesProvider = (props) => {
    const apiClient = useApiClient();
    const [categories, setCategories] = useState(new Map());
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const getCategory = (id) => categories.get(id.toUpperCase());
    const getChildCategories = (id) => Array.from(categories.values()).filter((category) => (category.parentId || null) ===
        (id?.toUpperCase() || null));
    const getAncestorCategories = (id) => {
        const ancestors = [];
        let currentCategory = categories.get(id.toUpperCase());
        while (currentCategory?.parentId) {
            const parentCategory = categories.get(currentCategory.parentId);
            if (parentCategory) {
                ancestors.push(parentCategory);
                currentCategory = parentCategory;
            }
            else {
                break;
            }
        }
        return ancestors.reverse();
    };
    const loadCategories = async () => {
        setIsLoading(true);
        const result = await callApi(apiClient.categories.getAll());
        if (result.error !== null) {
            setError(result.error);
        }
        else {
            setCategories(new Map(result.data.map((category) => [category.id, category])));
        }
        setIsLoading(false);
    };
    useEffect(() => {
        loadCategories();
    }, []);
    return (_jsx(CategoriesContext.Provider, { value: {
            getCategory,
            getChildCategories,
            getAncestorCategories,
            categoriesLoading: isLoading,
            categoriesError: error,
        }, children: props.children }));
};
export const useCategories = () => {
    const ctx = useContext(CategoriesContext);
    if (!ctx) {
        throw new Error('useCategoryHierarchy must be used within a CategoryHierarchyProvider');
    }
    return ctx;
};
